import { actions } from "./dashboard.actions";

const initialState = {
  porcentagem: {
    loading: false,
    data: [],
  },
  cotacoes: {
    loading: false,
    data: [],
  },
  hospitais: {
    loading: false,
    data: [],
  },
  seguradoras: {
    loading: false,
    data: [],
  },
  seguradoraPlanos: {
    loading: false,
    data: [],
  },
  seguradoraPeriodo: {
    loading: false,
    data: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.obterPorcentagem.REQUEST:
    case actions.obterPorcentagem.SUCCESS:
    case actions.obterPorcentagem.FAILURE:
      return {
        ...state,
        porcentagem: {
          ...state.porcentagem,
          loading: action.type === actions.obterPorcentagem.REQUEST,
          data:
            action.type === actions.obterPorcentagem.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.obterCotacoes.REQUEST:
    case actions.obterCotacoes.SUCCESS:
    case actions.obterCotacoes.FAILURE:
      return {
        ...state,
        cotacoes: {
          ...state.cotacoes,
          loading: action.type === actions.obterCotacoes.REQUEST,
          data:
            action.type === actions.obterCotacoes.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.obterHospitais.REQUEST:
    case actions.obterHospitais.SUCCESS:
    case actions.obterHospitais.FAILURE:
      return {
        ...state,
        hospitais: {
          ...state.hospitais,
          loading: action.type === actions.obterHospitais.REQUEST,
          data:
            action.type === actions.obterHospitais.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.obterSeguradoras.REQUEST:
    case actions.obterSeguradoras.SUCCESS:
    case actions.obterSeguradoras.FAILURE:
      return {
        ...state,
        seguradoras: {
          ...state.seguradoras,
          loading: action.type === actions.obterSeguradoras.REQUEST,
          data:
            action.type === actions.obterSeguradoras.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.obterSeguradoraPlanos.REQUEST:
    case actions.obterSeguradoraPlanos.SUCCESS:
    case actions.obterSeguradoraPlanos.FAILURE:
      return {
        ...state,
        seguradoraPlanos: {
          ...state.seguradoraPlanos,
          loading: action.type === actions.obterSeguradoraPlanos.REQUEST,
          data:
            action.type === actions.obterSeguradoraPlanos.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    case actions.obterSeguradoraPeriodo.REQUEST:
    case actions.obterSeguradoraPeriodo.SUCCESS:
    case actions.obterSeguradoraPeriodo.FAILURE:
      return {
        ...state,
        seguradoraPeriodo: {
          ...state.seguradoraPeriodo,
          loading: action.type === actions.obterSeguradoraPeriodo.REQUEST,
          data:
            action.type === actions.obterSeguradoraPeriodo.SUCCESS
              ? action.payload.response.data
              : [],
        },
      };
    default:
      return state;
  }
};

export default reducer;
